export default __webpack_public_path__ + "static/media/3.ca69ab43.jpg";